export const BreakPoints = {
  Tablet: 1024,
  Mobile: 744,
  MobileSmall: 384,
  MobileLandscape: 932,
};
